import { render, staticRenderFns } from "./MaterialManageList.vue?vue&type=template&id=5bfce971&scoped=true&"
import script from "./MaterialManageList.vue?vue&type=script&lang=js&"
export * from "./MaterialManageList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialManageList.vue?vue&type=style&index=0&id=5bfce971&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfce971",
  null
  
)

export default component.exports